<section id="features" class="section bg-contrast edge top-left">
  <div class="container">
    <div class="section-heading mb-6 text-center">
      <h5 class="text-primary bold small text-uppercase">
        Reasons to use DashCore
      </h5>
      <h2>Know what you can do Online</h2>
    </div>

    <div class="row gap-y text-center text-md-left">
      <div
        class="col-md-4 py-4 rounded shadow-hover text-center"
        *ngFor="let element of elements"
      >
        <div class="icon-shape mb-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 276.1 281.01"
            class="shape shape-xxl drop-shadow"
          >
            <defs>
              <style>
                .cls-1 {
                  fill: #53f;
                }
              </style>
            </defs>
            <g id="layer_2" data-name="layer 2">
              <g id="OBJECTS">
                <path
                  class="cls-1"
                  d="M261.95,86.82a83.45,83.45,0,0,0-8.57-10.71l0,0s-50.84-57.89-137-73.9l0,0A92.94,92.94,0,0,0,5,77.21c-17.58,85.56,16.63,154.31,16.83,154.72a83.17,83.17,0,0,0,6.67,11.93c21.11,31.38,60.18,43.83,96.07,33.7,0,0,58.12-14.28,123.33-79h0C278.76,169,285.58,121.95,261.95,86.82Z"
                />
              </g>
            </g>
          </svg>
          <dc-feather
            [name]="element.icon"
            [iconClass]="'stroke-contrast'"
            [class]="'icon center-xy'"
          ></dc-feather>
        </div>

        <h5 class="bold text-capitalize">{{ element.title }}</h5>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab dolores
          ea fugiat nesciunt quisquam. Assumenda dolore error nulla pariatur
          voluptatem?
        </p>
      </div>
    </div>
  </div>
</section>
